// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ece2d608","732":"c26c7c84","977":"692c7d3c"}[chunkId] + ".chunk.js";
};